import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { take } from 'rxjs';

import { DecreeActionTypeService } from '~/repositories/meeting/services/decree-action-type.service';

@Component({
  selector: 'app-detail-action-button-toggle-dialog',
  templateUrl: './detail-action-button-toggle-dialog.component.html',
  standalone: false,
  styleUrl: './detail-action-button-toggle-dialog.component.scss'
})
export class DetailActionButtonToggleDialogComponent implements OnInit {
  addActionForm: FormGroup;
  @Input() visible = false;
  @Input() url!: string;
  @Input() title!: string;
  @Input() meetingItemIds!: string[];
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() endAction = new EventEmitter<void>();

  constructor(private decreeActionTypeService: DecreeActionTypeService) {}

  ngOnInit(): void {
    this.addActionForm = new FormGroup({
      reason: new FormControl('')
    });
  }

  HandleAction() {
    if (this.meetingItemIds?.length === 0) {
      return;
    }

    this.decreeActionTypeService
      .toggleDetailAction(this.meetingItemIds, this.url, this.addActionForm.get('reason').value)
      .pipe(take(1))
      .subscribe();

    this.onClose();
  }

  onClose() {
    this.addActionForm.reset();
    this.visibleChange.emit(false);
    this.endAction.emit();
  }
}
